var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icon_arrow_down_svg__cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon_arrow_down_svg__cls-3",
    d: "M22.31 28.52c.58 0 1.8-1.12 1.8-1.12l12.4-12.84a1.15 1.15 0 111.66 1.6L24 30.8l-.88.87a1.17 1.17 0 01-1.64 0L6.58 16a1.15 1.15 0 011.66-1.6l12.4 13.42a2.62 2.62 0 001.67.71"
  }))));
}

export default SvgIconArrowDown;